import React, { useState, useEffect } from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'
import { adminApiAxiosInstance } from '../../services/api'

export const TextImageBoxWithIconsSettings = (props) => {

  const [urlOpts, setUrlOpts] = useState()
  const ctaVariantOpts = [
    { label: 'Primary', value: 'primary' },
    { label: 'Ghost', value: 'ghost' },
  ]
  const imagePosOptions = [
    { label: 'Sinistra', value: 'left' },
    { label: 'Destra', value: 'right' },
  ]
  const imageLabelVariantOptions = [
    { label: 'Verde', value: 'green' },
    { label: 'Blu', value: 'blue' },
    { label: 'Viola', value: 'purple' },
  ]
  const bgOptions = [
    { label: 'Nessuno', value: '' },
    { label: 'Bianco', value: 'white' },
  ]
  const titleSizeOptions = [
    { label: 'Md', value: 'md'},
    { label: 'Lg', value: 'lg'},
  ]

  useEffect(async () => {
    adminApiAxiosInstance.get('linkable_objects/').then(res => {
      setUrlOpts(
        res.data.reduce(
          (r, x) =>
            r.concat(
              x.linkable_objects.map(y => ({
                label: y.alias,
                value: x.content_type.id + '|' + y.id,
              }))
            ),
          []
        )
      )
    })
  }, [])

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="imagePos"
          type="select"
          options={imagePosOptions}
          label="Posizione immagine"
          defaultValue={defaultProps['imagePos']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="imageLabel"
          type="text"
          label="Label immagine"
          defaultValue={defaultProps['imageLabel']}
        /> 
        <ToolbarItem
          propKey="block"
          propSubKey="imageLabelVariant"
          type="select"
          options={imageLabelVariantOptions}
          label="Colore label immagine"
          defaultValue={defaultProps['imageLabelVariant']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="src"
          type="text"
          label="Src"
          description="Paste your url or upload a file"
          defaultValue={defaultProps['src']}
        />
        <ToolbarItem propKey="block" propSubKey="image" type="file" />
        <ToolbarItem
          propKey="block"
          propSubKey="bgVariant"
          type="select"
          options={bgOptions}
          label="Background"
          defaultValue={defaultProps['bgVariant']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="titleSize"
          type="select"
          options={titleSizeOptions}
          label="Dimensione titolo"
          defaultValue={defaultProps['titleSize']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="ctaLabel"
          type="text"
          label="Cta label"
          defaultValue={defaultProps['ctaLabel']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="ctaVariant"
          type="select"
          options={ctaVariantOpts}
          label="Cta style"
          defaultValue={defaultProps['ctaVariant']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="link"
          type="text"
          label="URL"
          defaultValue={defaultProps['link']}
        />
        {urlOpts && (
          <ToolbarItem
            propKey="block"
            propSubKey="pageLink"
            type="select"
            label="Page Link"
            options={urlOpts}
            nullable
            defaultValue={defaultProps['pageLink']}
          />
        )}
        <ToolbarItem
          propKey="block"
          propSubKey="openNewTab"
          type="switch"
          label="Open in new tab"
          defaultValue={defaultProps['openNewTab']}
        />
      </ToolbarSection>
    </>
  );
};
